import { FC, useState } from "react";
import { Box } from "@mui/material";
import { useLocation, Outlet } from "react-router-dom";
import StarSvg from "@/assets/svg/StarSvg";
import MenuItemCard from "../component/MenuItemCard";
import SettingTitle from "../component/SettingTitle";
import HeartCheckmark from "@/assets/svg/HeartCheckmark";
import theme from "@/theme";

const Premium: FC = () => {
  const location = useLocation();

  const [menuItems] = useState([
    {
      title: "Premium Subscription",
      subtitle: "Learn more about all premium features",
      icon: <StarSvg size={24} variant="outline" color={theme.palette.custom.blueGray600} />,
      link: "subscription",
    },
    {
      title: "Set or edit price of your like",
      subtitle: "Set your desired price for your like here",
      icon: <HeartCheckmark />,
      link: "like-price",
    },
  ]);

  const isRootPremium = location.pathname === "/settings/premium";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      {isRootPremium ? (
        <Box>
          <SettingTitle title="Premium Subscription" isActive />

          <Box bgcolor="white">
            {menuItems.map((item, index) => (
              <MenuItemCard key={index} item={item} />
            ))}
          </Box>
        </Box>
      ) : (
        <Box sx={{ maxWidth: "544px" }}>
          <Outlet />
        </Box>
      )}
    </Box>
  );
};

export default Premium;
